"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* The editor's quiet hints about built-in defaults: when the body uses
 * first_name or team_name without a typed fallback, it says what a missing
 * value becomes, and Change adds " | " so the sender can type their own. */
var _templateRenderer = require('./templateRenderer');








/* One hint per variable, for its first token without a fallback. */
 const defaultHints = (body, orgName) => {
  const hints = []
  for (const token of _templateRenderer.templateTokens.call(void 0, body)) {
    if (token.fallback !== null || hints.some(h => h.name === token.name)) continue
    const changeAt = token.index + token.text.length - 2
    if (token.name === 'first_name') hints.push({ name: 'first_name', text: 'Missing first names become "there".', changeAt })
    if (token.name === 'team_name') hints.push({ name: 'team_name', text: `Missing teams become "${orgName}".`, changeAt })
  }
  return hints
}; exports.defaultHints = defaultHints

/* The body with " | " added for a hint's Change, and where the caret goes. */
 const changeDefault = (body, hint) => ({
  body: `${body.slice(0, hint.changeAt)} | ${body.slice(hint.changeAt)}`,
  caret: hint.changeAt + 3,
}); exports.changeDefault = changeDefault
